import React from 'react';
import { AlertTriangleIcon } from 'lucide-react';
import { useCountdown } from '../hooks/useCountdown';
export function UrgencyBar() {
  const {
    hours,
    minutes,
    seconds
  } = useCountdown(5, 41, 22);
  const formatTime = (time: number) => time.toString().padStart(2, '0');
  return <div className="sticky top-0 z-50 w-full bg-red-600/90 backdrop-blur-md border-b border-red-500/50 px-4 py-3" data-id="element-117">
      <div className="max-w-7xl mx-auto flex flex-col sm:flex-row items-center justify-center gap-2 sm:gap-4 text-center" data-id="element-118">
        <div className="flex items-center gap-2 text-white font-medium text-sm sm:text-base" data-id="element-119">
          <AlertTriangleIcon className="w-5 h-5 animate-pulse" data-id="element-120" />
          <span data-id="element-121">
            <strong className="font-bold" data-id="element-122">ATENCIÓN:</strong> Oferta de
            lanzamiento disponible solo para los próximos 50 compradores. El
            precio subirá a $97 USD cuando el contador llegue a cero.
          </span>
        </div>
        <div className="font-mono font-bold text-white text-lg bg-black/20 px-3 py-1 rounded-md tracking-wider" data-id="element-123">
          [{formatTime(hours)}:{formatTime(minutes)}:{formatTime(seconds)}]
        </div>
      </div>
    </div>;
}